import { useState } from 'react';

import { ViewFile } from '.';

export const useViewModal = () => {
  const [viewFile, setViewFile] = useState<ViewFile>();
  const [isModalViewOpen, setIsModalViewOpen] = useState<boolean>(false);

  const handleViewFile = (file: ViewFile) => {
    setViewFile(file);

    setIsModalViewOpen(true);
  };

  const handleClose = () => {
    setIsModalViewOpen(false);

    setViewFile(undefined);
  };

  return {
    viewFile,
    handleViewFile,
    handleClose,
    isModalViewOpen,
  };
};
